import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Toolbar, Box, Button, Typography } from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useTranslation } from 'react-i18next';
import { ResmedLogo } from '@devx/1ux-aura-react-components';
import styles from './TopBar.module.scss';
const TopBar = ({ onManageAlert }) => {
    const { t } = useTranslation('translation', {
        keyPrefix: 'TOP_BAR'
    });
    return (_jsx(AppBar, { elevation: 0, position: "sticky", sx: {
            bgcolor: 'white',
            borderBottom: 'none',
            top: 0,
            zIndex: 1100
        }, children: _jsxs(Toolbar, { className: styles.header, children: [_jsxs(Box, { className: styles.logo_container, children: [_jsx(ResmedLogo, { id: "resmed-logo", isFullWidth: true }), _jsx(Typography, { variant: "h4", className: styles.title, children: t('APP_NAME') })] }), _jsx(Button, { variant: "outlined", startIcon: _jsx(NotificationsNoneOutlinedIcon, {}), className: styles.pill_button, "aria-label": t('DISMISS_ALERT_ARIA_LABEL'), onClick: onManageAlert, sx: {
                        borderColor: 'var(--color-brand) !important',
                        color: 'var(--color-brand) !important',
                        '&:hover': {
                            borderColor: 'var(--color-brand) !important',
                            backgroundColor: 'color-mix(in srgb, var(--color-brand) 8%, transparent)'
                        }
                    }, children: t('MANAGE_ALERT') })] }) }));
};
export default TopBar;
